import { VALUE_UNRESOLVED } from '../../Consts/backoffice.const';
import {
  SubscriptionOverrideCreatorResponse,
  SubscriptionOverrideResponse,
} from '../../Interfaces/api/backoffice/subscription.interface';
import { StatusTone } from '../../Modules/Shared/Types/status-tone.type';

export class SubscriptionOverride {
  id = '';
  subscription_item_id = '';
  original_unit_amount = 0;
  override_unit_amount = 0;
  currency: string | null = null;
  reason: string | null = null;
  status: string | null = null;
  starts_at: string | null = null;
  ends_at: string | null = null;
  stripe_price_id: string | null = null;
  created_by: SubscriptionOverrideCreatorResponse | null = null;
  created_at: string | null = null;

  constructor(data: Partial<SubscriptionOverrideResponse> = {}) {
    Object.assign(this, data);
  }

  get isActive(): boolean {
    return this.status === 'active';
  }

  get statusTone(): StatusTone {
    return this.isActive ? 'positive' : 'neutral';
  }

  get discountAmount(): number {
    return Math.max(0, this.original_unit_amount - this.override_unit_amount);
  }

  get authorLabel(): string {
    return this.created_by?.name || this.created_by?.email || VALUE_UNRESOLVED;
  }
}
